'use client';

import { fetchFavorites } from '@/clients/customer/favorites';
import { useCustomerFavoritesStore } from '@/stores/favorites';
import React, { useEffect } from 'react';
import useSWR from 'swr';

interface StoreFavoritesProps {
  params: any;
  userAuthToken?: string;
}

const fetcher = async (locale?: string) => {
  return fetchFavorites(null, {
    ['Accept-Language']: locale || 'en',
  }).then((res) => {
    return res?.data;
  });
};

const StoreFavorites = ({ params, userAuthToken }: StoreFavoritesProps) => {
  const setFavoritesData = useCustomerFavoritesStore((state) => state.setData);

  const {
    data: resData,
    // error,
    // isLoading,
  } = useSWR(
    userAuthToken ? ['customer-favorites', params?.locale] : null,
    ([, locale]) => fetcher(locale),
    {
      revalidateIfStale: true,
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
    }
  );

  useEffect(() => {
    if (resData) {
      setFavoritesData(resData);
    }
  }, [resData]);

  return null;
};

export default StoreFavorites;
